/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';
import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';

export const MyBox = styled(Box)`
  border-bottom: 1px solid ${Palette.PrimaryGray._200};

  .MuiTab-root {
    color: ${Palette.PrimaryGray._500};
    text-transform: none;
  }
  .Mui-selected {
    color: ${Palette.PrimaryGray._900} !important;
  }
`;

export const MyTab = styled(Tab)`
  font-size: 14px !important;
  padding: 0 !important;
  margin-left: 24px !important;
  min-height: 32px !important;
  height: 32px !important;
`;

export const MyTabs = styled(Tabs)`
  min-height: 32px !important;
  height: 32px !important;
  .MuiTabs-indicator {
    background-color: ${Palette.Primary._500};
  }
`;
